// LernpaketMiniCTA — schmale Espresso-Zeile am Kapitelende (Magazin-Anzeige)

import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const SHOP_OVERVIEW = 'https://dickies-helden.de/shop';

const LernpaketMiniCTA = ({ shopUrl, courseTitle }) => {
  const url = shopUrl || SHOP_OVERVIEW;
  const isDirect = !!shopUrl && shopUrl !== SHOP_OVERVIEW;

  const shortTitle = (courseTitle || '')
    .replace(/^Weiterbildung(?:\s+zur?)?\s+/i, '')
    .replace(/^Jährliche\s+/i, '')
    .trim();

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="lernpaket-mini-cta"
      className="group mt-10 block rounded-xl overflow-hidden"
      style={{ backgroundColor: '#23211E' }}
    >
      <div className="flex items-center gap-4 sm:gap-5 px-5 sm:px-6 py-3.5">
        <div className="flex-1 min-w-0 flex flex-wrap items-baseline gap-x-3 gap-y-0.5">
          <span className="font-mono text-[10px] uppercase font-semibold whitespace-nowrap" style={{ letterSpacing: '0.24em', color: '#8F650F' }}>
            Tiefer eintauchen
          </span>
          <span className="text-[13px] leading-snug truncate" style={{ color: 'rgba(245,240,234,0.8)' }}>
            {isDirect ? (
              <>Das komplette Skript zu <em className="font-display" style={{ color: '#F5F0EA' }}>{shortTitle}</em> gibt&apos;s als Print-Ausgabe.</>
            ) : (
              <>Alle Lernpakete zum Mitnehmen findest du in unserem Shop.</>
            )}
          </span>
        </div>

        <span className="flex-shrink-0 inline-flex items-center gap-1.5 text-[12px] font-semibold uppercase transition-opacity group-hover:opacity-80" style={{ letterSpacing: '0.14em', color: '#8F650F' }}>
          Zum Shop
          <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </a>
  );
};

export default LernpaketMiniCTA;
